const configNode=document.getElementById('vd-live-cart-config');
if(configNode){
 const config=JSON.parse(configNode.textContent);
 const slots=new Map();
 let pending=null;
 let running=false;
 let refreshedAt=0;
 const createSlot=(id,host,detail=false)=>{
  if(!/^\d+$/.test(id)||!host)return;
  let slot=detail?host.previousElementSibling:host.querySelector(':scope > .vd-live-cart-count');
  if(!slot?.classList.contains('vd-live-cart-count')){
   slot=document.createElement('span');slot.className='vd-live-cart-count'+(detail?' vd-live-cart-count--detail':'');slot.hidden=true;
   const icon=document.createElementNS('http://www.w3.org/2000/svg','svg');icon.setAttribute('viewBox','0 0 20 20');icon.setAttribute('fill','none');icon.setAttribute('aria-hidden','true');
   const path=document.createElementNS('http://www.w3.org/2000/svg','path');path.setAttribute('d','M2 3h2l2 9h9l2-6H5M7 16h.01M14 16h.01');path.setAttribute('stroke','currentColor');path.setAttribute('stroke-width','1.5');path.setAttribute('stroke-linecap','round');icon.append(path);
   slot.append(icon,document.createElement('span'));slot.title=config.details;
   if(detail)host.before(slot);else host.append(slot);
  }
  if(!slots.has(id))slots.set(id,new Set());slots.get(id).add(slot);
 };
 const collect=()=>{
  for(const [id,elements]of slots){for(const element of elements)if(!element.isConnected)elements.delete(element);if(!elements.size)slots.delete(id);}
  document.querySelectorAll('product-card[data-product-id]').forEach(card=>createSlot(card.dataset.productId,card.querySelector('.product-card__content')));
  const price=Array.from(document.querySelectorAll('main product-price[data-product-id]')).find(e=>!e.closest('product-card'));
  if(price)createSlot(price.dataset.productId,price,true);
 };
 const hideAll=()=>slots.forEach(elements=>elements.forEach(element=>element.hidden=true));
 const refresh=async()=>{
  if(running||document.visibilityState==='hidden')return;
  collect();if(!slots.size)return;running=true;
  try{
   const ids=[...slots.keys()];const counts={};
   for(let offset=0;offset<ids.length;offset+=100){
    const endpoint=new URL(config.endpoint);endpoint.searchParams.set('ids',ids.slice(offset,offset+100).join(','));
    const controller=new AbortController();const timeout=setTimeout(()=>controller.abort(),5000);
    let response;try{response=await fetch(endpoint,{credentials:'omit',signal:controller.signal});}finally{clearTimeout(timeout);}
    if(!response.ok)throw new Error('Counts unavailable');const data=await response.json();
    if(data.windowHours!==24||!data.counts)throw new Error('Invalid counts');
    const age=Date.now()-Date.parse(data.generatedAt);if(!Number.isFinite(age)||age>120000||age< -300000)throw new Error('Stale counts');
    Object.assign(counts,data.counts);
   }
   slots.forEach((elements,id)=>{
    const count=counts[id];const valid=Number.isSafeInteger(count)&&count>=config.minimum;
    elements.forEach(element=>{element.hidden=!valid;if(valid)element.lastElementChild.textContent=config.label.replace('__VD_CART_COUNT__',String(count));});
   });
   refreshedAt=Date.now();
  }catch{hideAll();}finally{running=false;}
 };
 const schedule=()=>{clearTimeout(pending);pending=setTimeout(refresh,250);};
 new MutationObserver(records=>{
  if(records.some(record=>Array.from(record.addedNodes).some(node=>node.nodeType===1&&(node.matches('product-card,product-price')||node.querySelector('product-card,product-price')))))schedule();
 }).observe(document.querySelector('main')||document.body,{childList:true,subtree:true});
 document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='visible'&&Date.now()-refreshedAt>30000)schedule();});
 setInterval(refresh,60000);
 refresh();
}
